<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleSidebar()">×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel">{{titleText | translate}}</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <button *ngIf="add === false && editMode === false" class="btn btn-sm btn-outline-success"
                        (click)="changeToEditMode()">{{'Edit' | translate}}</button>
                    <ng-container *ngIf="add === false&& editMode === false">
                        <p class="col-md-12">{{'Title' | translate}}: {{startProjectDetailForDisplay.title}}</p>
                        <div class="col-md-12">
                            <app-assign [assignedEmployeeId]="startProjectDetailForDisplay.assignedEmployeeId"
                                [token]="token"
                                [assignedEmployeeFullName]="startProjectDetailForDisplay.assignedEmployeeFullName"
                                [assignedEmployeePersonalPictureFileName]="startProjectDetailForDisplay.assignedEmployeePersonalPictureFileName"
                                [employeeDropdown]="employeeDropdown"
                                (employeeAssigned)="assigned($event)"></app-assign>
                        </div>
                        <div class="col-md-12"
                            *ngIf="startProjectDetailForDisplay.assignedEmployeeId !== null && token === 'dashboardToken'">
                            <div class="form-group">
                                <label class="form-label" for="ticketStatus">{{'Status' | translate}}</label>
                                <select class="form-control form-control-sm" id="ticketStatus" name="ticketStatus"
                                    [(ngModel)]="startProjectDetailForDisplay.projectStatus"
                                    (change)="changeProjectStatus()">
                                    <option [ngValue]="null">{{'PleaseSelectAnyItem' | translate}}
                                    </option>
                                    <ng-container *ngFor="let enumItem of projectStatus | enumKey">
                                        <option [ngValue]="enumItem.key"
                                            *ngIf="enumItem.key !== projectStatus.Unassigned">
                                            {{enumItem.value | translate}}
                                        </option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <p class="col-md-12">{{'Description' | translate}}:</p>
                        <article class="col-md-12">
                            <pre>{{startProjectDetailForDisplay.description}}</pre>
                        </article>
                    </ng-container>
                    <ng-container *ngIf="add === true || editMode === true">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="name">{{'Name' | translate}}</label>
                                <input type="text" class="form-control form-control-sm" id="name" name="name"
                                    placeholder="{{'Name' | translate}}" [(ngModel)]="name"
                                    [ngClass]="{'is-invalid' : (nameIsInvalid === true)}" required />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="order">{{'Order' | translate}}</label>
                                <input type="number" class="form-control form-control-sm" id="order" name="order"
                                    placeholder="{{'Order' | translate}}" [(ngModel)]="order"
                                    [ngClass]="{'is-invalid' : (orderIsInvalid === true)}" required />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="description">{{'Description' | translate}}</label>
                                <textarea class="form-control form-control-sm" id="description" name="description"
                                    placeholder="{{'Description' | translate}}" [(ngModel)]="description"></textarea>
                            </div>
                        </div>
                        <button class="btn btn-sm btn-outline-success" (click)="submit()">
                            {{(add === true?'Add':'Edit') | translate}}</button>
                        <button *ngIf="add === false" id="cancelButton" class="btn btn-sm btn-outline-secondary"
                            (click)="changeToEditMode()">{{'Cancel' | translate}}</button>
                    </ng-container>
                </div>
            </form>
        </div>
    </div>
</div>
<app-alert [result]="result"></app-alert>